import AbstractEventTypeModel from './AbstractEventTypeModel';
import { RenderNameProps }    from '@widesk-ui/mixins/ApiModelRenderName';

export default class EventTypeModel extends AbstractEventTypeModel {
	public renderName(props?: RenderNameProps<this> & ColorNameProps) {
		return super.renderName(props);
	}
}
